var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n    .cls-1{fill:#f05253;}.cls-2{fill:#fab139;}.cls-3{fill:none;}\n"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.13,126.18a13.05,13.05,0,0,1-3.84,9.26l-55.1,55.1c-4.83,4.83-12.68,5.61-17.94,1.26a13.09,13.09,0,0,1-1-19.37l36.09-36.08a14.35,14.35,0,0,0,0-20.32L161.71,99.35a14.37,14.37,0,0,0-20.32,0L105.73,135c-5.26,5.26-14.18,5.55-19.26.1a13.07,13.07,0,0,1,.33-18.17l55.49-55.49a13.08,13.08,0,0,1,18.5,0l55.5,55.49A13,13,0,0,1,220.13,126.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167,123.79A13,13,0,0,1,163.2,133l-55.49,55.5a13.08,13.08,0,0,1-18.5,0L33.71,133a13.06,13.06,0,0,1,0-18.5L89.16,59.09c.1-.12.21-.13,1-.74,4.62-3.59,11.18-4.14,15.91-.7a13.08,13.08,0,0,1,1.65,19.89s0,0,0,0l-36,36a14.35,14.35,0,0,0,0,20.32L88.3,150.63a14.37,14.37,0,0,0,20.32,0l36.09-36.09A13.09,13.09,0,0,1,167,123.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 250,
    height: 250
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVps);
export default __webpack_public_path__ + "static/media/vps.fa59ae1867436f7c2c0bf8886435404e.svg";
export { ForwardRef as ReactComponent };